var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "false",
    "aria-label": "OP",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    className: "ds-logo",
    height: 48,
    "data-test-id": "nav-logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0a25 25 0 1 0 0 50 25 25 0 1 0 0-50z",
    fill: "#ff6a10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 44.5h-5V34.2c-1.7 1.1-3.8 1.8-6 1.8-6.1 0-11-4.9-11-11s4.9-11 11-11c2.2 0 4.3.7 6 1.8V5.5h5v10.3c1.7-1.1 3.8-1.8 6-1.8 6.1 0 11 4.9 11 11s-4.9 11-11 11c-2.2 0-4.3-.7-6-1.8v10.3zm6-25.5c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm-17 0c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpLogo);
export default __webpack_public_path__ + "static/media/op-logo.f4d73bb0.svg";
export { ForwardRef as ReactComponent };